import React, { useEffect, useRef, useState } from 'react'
import Header from "../../template/Header";
import Menu from "../../template/Menu";
import Footer from "../../template/Footer";
import Loading from "../../components/loading/Loading";
import { Col, Row, Form } from "react-bootstrap";
import {
    textSearchBtn,
    textResetBtn,
    textCreateBtn,
    colorSearchBtn,
    colorResetBtn,
    colorCreateBtn,
    iconSearchBtn,
    iconResetBtn,
    iconCreateBtn,
    hoverSearchBtn,
    hoverResetBtn,
    hoverCreateBtn,
    textSaveBtn,
    textCancleBtn,
    colorSaveBtn,
    colorCancleBtn,
    hoverSaveBtn,
    hoverCancleBtn,
    colorEditBtns,
    hoverEditBtns
} from "../../components/ThemeConfig/btnConfig";
import { useButtonDynamicStyles } from "../../components/useDynamic/Button_DynamicStyle";
import { useNavigate } from 'react-router-dom';
import { setTimeOutSync } from "../../utils/setTimeout";
import Text from '../../components/inputTxt/Text';
import { createBusRetailDir, getBusRetailDirById, updateBusRetailDir } from "../../api/business_api";
import Dropdown from "../../components/dropdowns/Dropdown"
import UploadIMG from "../../components/uploads/UploadIMG";
import { urlToBlob } from '../../utils/function';
import { FLOOR } from '../../utils/const';
import {
    alertValidateData,
    alertOverLimit,
    alertConfirmSave,
    alertSaved,
    alertCancel,
    alertNotFound
} from "../../components/alertValid/AlertValid.js"
import CustomCKEditor from '../../components/ckEditor/CustomCKEditor.js';

function AddEditDirectory() {
    useButtonDynamicStyles(
        textSearchBtn,
        textResetBtn,
        textCreateBtn,
        colorSearchBtn,
        colorResetBtn,
        colorCreateBtn,
        iconSearchBtn,
        iconResetBtn,
        iconCreateBtn,
        hoverSearchBtn,
        hoverResetBtn,
        hoverCreateBtn,
        textSaveBtn,
        textCancleBtn,
        colorSaveBtn,
        colorCancleBtn,
        hoverSaveBtn,
        hoverCancleBtn,
        colorEditBtns,
        hoverEditBtns
    );
    
    const [isLoading, setLoading] = useState(false);

    const [editId, setEditId] = useState(null);
    const [active, setActive] = useState(true);
    const [txtEnTitle, setTxtEnTitle] = useState('');
    const [txtThTitle, setTxtThTitle] = useState('');
    const [txtEnDesc, setTxtEnDesc] = useState('');
    const [txtThDesc, setTxtThDesc] = useState('');
    const [txtEnAddress, setTxtEnAddress] = useState('');
    const [txtThAddress, setTxtThAddress] = useState('');
    const [noRoom, setNoRoom] = useState("");
    const [tel, setTel] = useState("");
    const [time, setTime] = useState("");
    const [floor, setFloor] = useState(FLOOR);

    const [images1, setImages1] = useState([]);
    const [imagesFromApi1, setImagesFromApi1] = useState([]);

    const [inputForm, setInputForm] = useState({
        Floor: 0,
        noRoom: "",
        tel: "",
        time: ""
    });

    function setinput(inputname, value) {
        setInputForm((prev) => {
            return {
                ...prev,
                [inputname]: value,
            };
        });
    }

    const onChangeInputRoom = (e) => {
        if (e) {
            setinput("noRoom", e.target.value);
            setNoRoom(e.target.value);
        }
    };

    const onChangeInputTel = (e) => {
        if (e) {
            setinput("tel", e.target.value);
            setTel(e.target.value);
        }
    };

    const onChangeInputTime = (e) => {
        if (e) {
            setinput("tel", e.target.value);
            setTime(e.target.value);
        }
    };

    const handleSelectedImages1 = (images) => {
        setImages1(images);
    };
    const handleSelectedRemoveImg1 = (data) => {
        setImages1(data);
    };

    const [valuefromparent1, setValuefromparent1] = useState("---Select---");
    const [selectedFloor, setSelecteFloor] = useState("");

    const handleFloorChange = (value) => {
        setSelecteFloor(value);
    };

    const ChangesetValuefromparent1 = (text) =>  {
        setValuefromparent1(text);
    }

    const handleChangeInput50 = async (event,inpName) => {
        const inputValue = event.target.value;
        if (inputValue.length >= 50) {
            const result = await alertOverLimit();
                if (result.isConfirmed) {
                    const trimmedValue = inputValue.substring(0, 50); // Trim to 50 characters
                    //const lastSpaceIndex = trimmedValue.lastIndexOf(" ");
                    const finalValue = trimmedValue.substring(0); // Trim at last space
                    if (inpName=='enTitle') {                    
                        setTxtEnTitle(finalValue);
                    }
                    else if (inpName == 'thTitle') {
                        setTxtThTitle(finalValue);
                    }
                    else if (inpName == 'enAddress') {
                        setTxtEnAddress(finalValue);
                    }
                    else if (inpName == 'thAddress') {
                        setTxtThAddress(finalValue);
                    }
                }
                else {
                    if (inpName == 'enTitle') {                    
                        setTxtEnTitle(inputValue);
                    }
                    else if (inpName == 'thTitle') {
                        setTxtThTitle(inputValue);
                    }
                    else if (inpName == 'enAddress') {
                        setTxtEnAddress(inputValue);
                    }
                    else if (inpName == 'thAddress') {
                        setTxtThAddress(inputValue);
                    }
                }
        }
        else {
            if (inpName == 'enTitle') {                    
                setTxtEnTitle(inputValue);
            }
            else if (inpName == 'thTitle') {
                setTxtThTitle(inputValue);
            }
            else if (inpName == 'enAddress') {
                setTxtEnAddress(inputValue);
            }
            else if (inpName == 'thAddress') {
                setTxtThAddress(inputValue);
            }
        }
    };

    const alertValidate = async () => {
        const result = await alertValidateData();
            if (result.isConfirmed) {
                return;
            } else {
                return;
            }
    }

    const createDirectoryData = async () => {
        let body = {
            name_en: txtEnTitle,
            name_th: txtThTitle,
            description_en: txtEnDesc,
            description_th: txtThDesc,
            address_en: txtEnAddress,
            address_th: txtThAddress,
            floor: selectedFloor,
            unit: noRoom,
            tel: tel,
            room_no: noRoom,
            gallery: images1,
            open_time: time,
            active: active == false ? 0 : 1,
          };
          if (
            !body.name_en ||
            !body.name_th ||
            !body.description_en ||
            !body.description_th ||
            !body.address_en ||
            !body.address_th ||
            body.gallery.length <= 0
          ) {
            await alertValidate();
          } else {
            const result = await alertConfirmSave();
              if (result.isConfirmed) {
                (async () => {
                  await setLoading(true);
                  const response = await createBusRetailDir(body);
                  setTimeOutSync(() => setLoading(false)).then(async () => {
                    if (response.data.status == "success") {
                        const res = await alertSaved();
                        if (res.isConfirmed) {
                          navigateToBack("/infoDirectory");
                        }
                    }
                  }).finally(() => setLoading(false))
                })();
              }
          }
    };

    const updateDirectoryData = async (id) => {
        let body = {
            name_en: txtEnTitle,
            name_th: txtThTitle,
            description_en: txtEnDesc,
            description_th: txtThDesc,
            address_en: txtEnAddress,
            address_th: txtThAddress,
            floor: selectedFloor,
            tel: tel,
            room_no: noRoom,
            gallery: images1,
            open_time: time,
            active: active == false ? 0 : 1,
          };
        if (
            !body.name_en ||
            !body.name_th ||
            !body.description_en ||
            !body.description_th ||
            !body.address_en ||
            !body.address_th ||
            body.gallery.length <= 0
        ) {
            await alertValidate();
        } else {
            const result = await alertConfirmSave();
            if (result.isConfirmed) {
              await setLoading(true);
              const response = await updateBusRetailDir(id, body);
              setTimeOutSync(() => setLoading(false)).then(async () => {
                if (response.data.status == "success") {
                    const res = await alertSaved();
                    if (res.isConfirmed) {
                      navigateToBack("/infoDirectory");
                    }
                }else{
                    const res = await alertNotFound();
                        if (res.isConfirmed) {
                            navigateToBack("/infoDirectory");
                        } else {
                            navigateToBack("/infoDirectory");
                        }
                }
              }).catch((err) => {
                
              }).finally(() => setLoading(false))
            }
        }
      };

    const handleActiveBtn = async (idData) => {
        if (idData) {
            updateDirectoryData(idData);
        } else {
            createDirectoryData();
        }
    };
    
    const navigate = useNavigate();
    const navigateToBack = (page) => {
        navigate(page);
    };
    
    const fetchDirectoryById = async (id) => {
        const result = await getBusRetailDirById(id)
        if(!result){
            const res = await alertNotFound();
                if (res.isConfirmed) {
                    navigate('/infoDirectory')
                } else {
                    navigate('/infoDirectory')
                }
        }
        if(result.status == 200) {
            const resData = result.data.data
            setTxtEnTitle(resData?.name_en)
            setTxtThTitle(resData?.name_th)
            setTxtEnAddress(resData?.address_en)
            setTxtThAddress(resData?.address_th)
            setTxtEnDesc(resData?.description_en)
            setTxtThDesc(resData?.description_th)
            setActive(resData?.active) 
            setSelecteFloor(resData?.floor)
            
            // selectedFloor
            setNoRoom(resData?.room_no)
            setTel(resData?.tel)
            setTime(resData?.open_time)

            const imgsGallery = resData.gallery;
            if (imgsGallery && Array.isArray(imgsGallery)) {
                const images = await Promise.all(imgsGallery.map(async (imageSrc, index) => {
                    return {
                        id: index,
                        status: false,
                        src: imageSrc || '',
                        file: imageSrc ? await urlToBlob(imageSrc) : null,
                        size: 1024 * 1024 * 4, // hard-coded to pass validation
                        type: 'image/jpg' // hard-coded to pass validation
                    };
                }));
                setImagesFromApi1(images);
            }
    
        }
        
    }

    const handleClickCancel = async () => {
        const res = await alertCancel();
            if (res.isConfirmed) {
              navigateToBack("/infoDirectory");
            }
            else { }
      };

    let apiCalled = useRef(false); // Flag variable

    useEffect(() => {
            apiCalled.current = true;
            let id = new URLSearchParams(window.location.search).get("id");
            if (id) {
                setEditId(id);
                fetchDirectoryById(id);
            }
    }, []);
  return (
    <>
        <style>
            {`
                .select {
                    width: 100% !important;
                    height: 42px !important;
                    border: 1px solid #D1D3D4 !important;
                    border-radius: .25rem !important;
                    padding: 10px 5px !important;
                }
                .ic-dropdown {
                    width: 23px !important;
                    padding: 5px !important;
                }
                .options-list {
                    width: 96% !important;
                    border-radius: 6px;
                }
                .upload {
                    display: flex;
                    flex-direction: column; /* Stack items vertically by default */
                    position: relative;
                }
                .thumbsContainer {
                    display: flex; /* Change to flex to align children horizontally */
                    flex-wrap: wrap; /* Allow wrapping to the next line if needed */
                    width: 100%;
                    margin-top: 0;
                }
                .thumb, .boxthumb {
                    display: inline-flex;
                    border-radius: 0;
                    margin: 0 5px 10px 0; /* Margin to space items horizontally and vertically */
                    width: 100px; /* Adjust the width to fit your design */
                    height: 70px;
                    box-sizing: border-box;
                    position: relative;
                    margin-top: 1rem;
                }
                .ck.ck-editor__main>.ck-editor__editable:not(.ck-focused) {
                    height: 200px;
                }
                @media only screen and (max-width: 767px) {
                    .thumb, .boxthumb {
                        margin-left: 0;
                        margin-right: 15px;
                    }
                    .remark-dt {
                        margin-top: -25px;
                    }
                }
                @media (min-height: 788px) { 
                    .pdb-page {
                        padding-bottom: calc(19rem + 1px) !important;
                    }
                }
            `}
        </style>
        {isLoading ? <Loading /> : ""}
        <Header parentmenu={"BUSINESS"} />
        <Menu
            parentmenu={"infoBusiness"}
            activemenu={"infoDirectory"}
        />
        <div className="content-wrapper">
            <div className="container-fluid pdb-page">
                <div className="box-white">
                    <Row>
                        <Col xs={12}>
                            {editId ? (
                            <font className="font-size07 colorBlack01 fontBold d-flex align-items-center">
                                <img src="assets/icons/ic-business.png" className="ic-user01 me-2" alt="" />
                                EDIT DIRECTORY
                            </font>
                            ) : (
                            <font className="font-size07 colorBlack01 fontBold d-flex align-items-center">
                                <img src="assets/icons/ic-business.png" className="ic-user01 me-2" alt="" />
                                ADD DIRECTORY
                            </font>
                            )}
                        </Col>
                    </Row>
                    <Row className="ms-5 mt-3 d-flex align-items-center">
                        <Col xs={12}>
                            <label className="fontLight font-size03 colorBlack01">
                            Directory
                            </label>
                        </Col>
                    </Row>
                    <Row className="ms-5 mt-3 d-flex align-items-center">
                        <Col xs={6}>
                            <font className="font-size01 colorBlue01 fontMed text-decoration-underline">
                                English
                            </font>
                        </Col>
                        <Col xs={6}>
                            <font className="font-size01 colorBlue01 fontMed text-decoration-underline">
                                ภาษาไทย
                            </font>
                        </Col>
                    </Row>
                    <Row className='ms-5 mt-2'>
                        <Col xs={6}>
                            <Text
                                value={txtEnTitle}
                                onChange={(e) => handleChangeInput50(e,'enTitle')}
                                placeholder="Title *"
                            />
                        </Col>
                        <Col xs={6}>
                            <Text
                                value={txtThTitle}
                                onChange={(e) => handleChangeInput50(e,'thTitle')}
                                placeholder="ข้อเรื่อง *"
                            />
                        </Col>
                    </Row>
                    <Row className='ms-5 mt-2'>
                        <Col xs={6}>
                            <CustomCKEditor
                                data={txtEnDesc}
                                onChange={(newData) => {
                                    setTxtEnDesc(newData);
                                }}
                                placeholder="Description *"
                            />
                        </Col>
                        <Col xs={6}>
                            <CustomCKEditor
                                data={txtThDesc}
                                onChange={(newData) => {
                                    setTxtThDesc(newData);
                                }}
                                placeholder="คำอธิบาย *"
                            />
                        </Col>
                    </Row>
                    <Row className='ms-5 mt-2'>
                        <Col xs={6}>
                            <Text
                                value={txtEnAddress}
                                onChange={(e) => handleChangeInput50(e,'enAddress')}
                                placeholder="Address *"
                            />
                        </Col>
                        <Col xs={6}>
                            <Text
                                value={txtThAddress}
                                onChange={(e) => handleChangeInput50(e,'thAddress')}
                                placeholder="ที่อยู่ *"
                            />
                        </Col>
                    </Row>
                    <Row className='ms-5 mt-2'>
                        <Col xs={3} className="d-flex flex-row align-items-center">
                            <div className="w-25">
                                <font className="fontLight font-size03 colorBlack01 me-2">
                                Floor
                                </font>
                            </div>
                            <div className="w-100 position-relative">
                                <Dropdown
                                    // options={DataDropFloor}
                                    options={floor}
                                    setinput={setinput}
                                    inputname={"Floor"}
                                    ChangesetValuefromparent={ChangesetValuefromparent1}
                                    // valuefromparent={valuefromparent1}
                                    valuefromparent={floor.find((item => item.value === selectedFloor)) ? floor.find((item => item.value === selectedFloor)).text : valuefromparent1}
                                    onChange={handleFloorChange}
                                />
                            </div>
                        </Col>
                        <Col xs={3} className="d-flex flex-row align-items-center">
                            <div className="w-25">
                                <font className="fontLight font-size03 colorBlack01 me-2">
                                No. Room
                                </font>
                            </div>
                            <div className="w-100">
                                <input
                                    type="text"
                                    className="inp01 fontLight font-size03"
                                    id="no_room"
                                    placeholder="ลำดับชั้น"
                                    value={noRoom}
                                    onChange={onChangeInputRoom}
                                />
                            </div>
                        </Col>
                        <Col xs={3} className="d-flex flex-row align-items-center">
                            <div className="w-25">
                                <font className="fontLight font-size03 colorBlack01 me-2">
                                Tel.
                                </font>
                            </div>
                            <div className="w-100">
                                <input
                                    type="text"
                                    className="inp01 fontLight font-size03"
                                    id="tel"
                                    placeholder="0814563289"
                                    value={tel}
                                    onChange={onChangeInputTel}
                                />
                            </div>
                        </Col>
                        <Col xs={3} className="d-flex flex-row align-items-center">
                            <div className="w-50">
                                <font className="fontLight font-size03 colorBlack01 me-2">
                                Open Time
                                </font>
                            </div>
                            <div className="w-100">
                                <input
                                    type="text"
                                    className="inp01 fontLight font-size03"
                                    id="time"
                                    placeholder="Mon - Fri, 8.30 - 17.00"
                                    value={time}
                                    onChange={onChangeInputTime}
                                />
                            </div>
                        </Col>
                    </Row>
                </div>
                <div className="box-white mt-4">
                    <div className='mx-5 mt-4'>
                        <Row>
                            <Col xs={12}>
                                <font className="font-size01 colorBlack01 fontBold">
                                Gallery Album / image <span className=' colorRed'>*</span>
                                </font>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12}>
                                <UploadIMG
                                    limit={10}
                                    onSelectedImages={handleSelectedImages1}
                                    images={imagesFromApi1}
                                    txtDetail={"jpg. / 800x450 px , limit size 5MB"}
                                    removeImg={handleSelectedRemoveImg1}
                                />
                            </Col>
                        </Row>
                    </div>
                </div>
                <div className="box-white mt-4">
                    <div className='mx-5 mt-4'>
                        <Row>
                            <Col xs={12} className="p-0">
                                <label className="fontLight font-size03 colorBlack01">
                                Status
                                </label>
                            </Col>
                        </Row>
                        <Form>
                            {["radio"].map((type) => (
                                <div key={`inline3-${type}`} className="mt-2 mb-3">
                                <Form.Check
                                    className="fontLight font-size03 colorBlack01 checked"
                                    inline
                                    label="Active"
                                    name="group3"
                                    type={type}
                                    id={`inline3-${type}-1`}
                                    checked={active}
                                    onChange={(e) => setActive(true)}
                                />
                                <Form.Check
                                    className="fontLight font-size03 colorBlack01"
                                    inline
                                    label="Inactive"
                                    name="group3"
                                    type={type}
                                    id={`inline3-${type}-2`}
                                    checked={!active}
                                    onChange={(e) => setActive(false)}
                                />
                                </div>
                            ))}
                        </Form>
                    </div>
                </div>
                <Row className="ms-5 mt-4">
                    <Col xs={1} className="p-0 d-flex justify-content-start me-4">
                    <button
                        className="btn-cancle01"
                        onClick={() => handleClickCancel()}
                    >
                        CANCEL
                    </button>
                    </Col>
                    <Col xs={1} className="p-0 d-flex justify-content-start">
                    <button
                        className="btn-save01"
                        onClick={(e) => {
                        handleActiveBtn(editId);
                        }}
                    >
                        SAVE
                    </button>
                    </Col>
                </Row>
            </div>
        </div>
        <Footer/>
    </>
  )
}

export default AddEditDirectory;